export enum EnumTareaAccion {
  RETRYFDIST = 'RETRYFDIST',
  FIX_DISC_ATR = 'FIX_DISC_ATR',
  FIX_DISC_ACTIVACION = 'FIX_DISC_ACTIVACION',
  SWT_ANALISIS_RECHAZO = 'SWT_ANALISIS_RECHAZO',
  REDIRECT_TO_LEAD = 'REDIRECT_TO_LEAD'
}
